import PropTypes from 'prop-types';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
// @mui
import { Alert, AlertTitle, Container, Stack } from '@mui/material';
// components
import { useSettingsContext } from '../components/settings';
//
import { getSysInfo } from '../api/sysApi';
import MessageMarkdown from './MessageMarkdown';

// ----------------------------------------------------------------------
// Notices an admin added for the current page (Student Messages > page messages in the admin
// app). They're info rows whose category is "page:" + the page's path, e.g. "page:/dashboard/home".

PageMessages.propTypes = {
  container: PropTypes.bool,
  sx: PropTypes.object,
};

export default function PageMessages({ container = false, sx }) {
  const { themeStretch } = useSettingsContext();
  const { pathname } = useLocation();
  const category = `page:${pathname.replace(/\/+$/, '') || '/'}`;

  const { data } = useQuery({
    queryKey: ['sysInfo', category], queryFn: async () => {
      const d = await getSysInfo(encodeURIComponent(category));
      if (d.data) return d.data;
      return [];
    }, refetchOnWindowFocus: false,
  });

  if (!data?.length) return null;

  const messages = (
    <Stack spacing={2} sx={sx}>
      {data.map((i) => (
        <Alert key={i.id} severity="info">
          {i.title && <AlertTitle>{i.title}</AlertTitle>}
          <MessageMarkdown>{i.description}</MessageMarkdown>
        </Alert>
      ))}
    </Stack>
  );

  // Line up with the page content, which sits in the same Container
  return container ? <Container maxWidth={themeStretch ? false : 'xl'}>{messages}</Container> : messages;
}
